import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  TemplateRef,
} from '@angular/core';
import { Ag1TitleComponent } from '../ag1-title/ag1-title.component';
import { Bind } from 'primeng/bind';
import { Divider } from 'primeng/divider';
import { Tabs, TabList, Tab } from 'primeng/tabs';
import { Ripple } from 'primeng/ripple';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'ag1-title-bar',
  templateUrl: './ag1-title-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    Ag1TitleComponent,
    Bind,
    Divider,
    Tabs,
    TabList,
    Ripple,
    Tab,
    RouterLink,
    NgTemplateOutlet,
  ],
})
export class Ag1TitleBarComponent {
  // inputs
  label = input.required<string>();
  activeTab = input<string>('');
  tabs = input<{ route: string; label: string }[]>([]);
  actionsTemplateRef = input<TemplateRef<any>>();
  state = input<'new' | 'beta' | 'alpha'>();
  showIfSingleTab = input<boolean>(false); // controls whether to show tabs if there is only one tab

  // computed signals
  showTabs = computed(() => {
    const tabs = this.tabs();
    if (tabs.length === 1) {
      return this.showIfSingleTab();
    }

    return tabs.length > 1;
  });
}
